// src/config/gtmConfig.ts

/**
 * Google Tag Manager configuration
 */
const analyticsConfig = {
  /**
   * Google Tag Manager container ID
   */
  gtmId: 'GTM-NG2Z4DCG',

  /**
   * Enable/disable analytics in development
   */
  enableInDevelopment: true,

  /**
   * Custom domain that serves the GTM container (gtm.js)
   */
  gtmHost: 'https://atycs.hoptira.com',

  /**
   * Whether analytics should be enabled based on current environment
   */
  get isEnabled(): boolean {
    const isDev = import.meta.env.DEV;
    return !isDev || this.enableInDevelopment;
  },
};

export default analyticsConfig;
